module.exports = __webpack_public_path__ + "img/BE0400028394.0d0e8595.svg";